export const CONTACT_EMAIL = 'breathingroom@cinim.org',
  PRIVACY_POLICY_URL = 'https://www.breathingroom.me/privacy-policy/',
  INSTITUTION_CODE_HELP_URL =
    'https://www.breathingroom.me/schools-institutions',
  BREATHINGROOM_WEBSITE_URL = 'https://www.breathingroom.me',
  TERMS_OF_USE_URL = 'https://www.breathingroom.me/terms-of-use/',
  APP_STORE_URL = 'https://apps.apple.com/ca/app/breathingroom/id923465123',
  IOS_REVIEW_URL =
    'https://apps.apple.com/ca/app/breathingroom/id923465123?action=write-review',
  GOOGLE_PLAY_URL =
    'https://play.google.com/store/apps/details?id=cinim.BreathingRoom';
